import React from 'react';
import { Card as MuiCard, CardContent, Typography, styled } from '@mui/material';

export interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
  padding?: 'none' | 'small' | 'medium' | 'large';
}

const StyledCard = styled(MuiCard)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid #BCBCBC',
  boxShadow: '0 2px 6px 0 rgba(0,0,0,0.16)',
}));

const StyledCardContent = styled(CardContent, {
  shouldForwardProp: (prop) => prop !== 'customPadding'
})<{ customPadding: 'none' | 'small' | 'medium' | 'large' }>(({ theme, customPadding }) => {
  const paddingMap = {
    none: 0,
    small: theme.spacing(1.5),
    medium: theme.spacing(3),
    large: theme.spacing(4),
  };

  return {
    padding: paddingMap[customPadding],
    '&:last-child': {
      paddingBottom: paddingMap[customPadding],
    },
  };
});

const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 400,
  color: '#424242',
  marginBottom: theme.spacing(2),
  lineHeight: 1.6,
}));

export const Card: React.FC<CardProps> = ({ 
  children, 
  title, 
  className = '',
  padding = 'medium'
}) => {
  return (
    <StyledCard className={className}>
      <StyledCardContent customPadding={padding}>
        {title && (
          <CardTitle variant="h2" component="h2">
            {title}
          </CardTitle>
        )}
        {children}
      </StyledCardContent>
    </StyledCard>
  );
};